import { TranslocoService } from '@jsverse/transloco';
import {
  Component,
  OnInit,
  OnDestroy,
  ChangeDetectionStrategy,
} from '@angular/core';
import { MenuItem } from 'primeng/api';
import { AppNav } from 'src/routes/app-nav';
import { NavItem } from 'src/interfaces/navitem.interface';
import { UserDTO } from 'src/classes/userDTO';
import { UserService } from 'src/services/user.service';
import { Subject } from 'rxjs';
import { filter, pluck, takeUntil } from 'rxjs/operators';
import { AuthService } from '@/services/auth.service';

@Component({
  selector: 'app-masthead',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './masthead.component.html',
})
export class MastheadComponent implements OnInit, OnDestroy {
  user?: UserDTO;
  menuItems: { [key: string]: NavItem | any }[] = [];
  accountMenuItems: MenuItem[] = [];
  helpVisible: boolean = false;
  markupLoaded: boolean = false;
  helpPath: string = '';
  helpDownloadUrl: string = '';
  private readonly _destroying$ = new Subject<void>();

  constructor(
    private translocoService: TranslocoService,
    private authService: AuthService,
    private userService: UserService,
  ) {}

  ngOnInit() {
    this.userService.getLoggedInUser().subscribe((x) => (this.user = x));

    this.setMenuItems();
    this.setAccountMenuItems();

    this.translocoService.events$
      .pipe(
        filter((e) => e.type === 'translationLoadSuccess'),
        takeUntil(this._destroying$),
        pluck('payload'),
      )
      .subscribe(({ langName, scope }) => {
        this.setAccountMenuItems();
      });
  }

  setMenuItems() {
    this.menuItems = [
      { page: AppNav.QueryInvoices },
      { page: AppNav.TransactionQuery },
      {
        page: AppNav.StatusMonitor,
        children: [
          { page: AppNav.QueryInvoicesStatus },
          { page: AppNav.TransactionQueryStatus },
        ],
      },
      {
        page: AppNav.AccessManagement,
        children: [{ page: AppNav.RequestAccess }],
      },
    ];

    var roles: string[] | undefined;
    this.userService.getLoggedInUser().subscribe((x) => (roles = x?.userRoles));

    if (roles?.includes('Admin') || roles?.includes('EngagementManager')) {
      this.menuItems[3].children.push({ page: AppNav.AccessRequests });
      this.menuItems[3].children.push({ page: AppNav.ManageEngagements });
    }

    if (roles?.includes('Admin')) {
      this.menuItems = [
        ...this.menuItems,
        {
          page: AppNav.Admin,
          children: [{ page: AppNav.AdmminManageTechnicalUsers }],
        },
      ];
    }
  }

  onClickedOutside(e: any, menuItem: any) {
    menuItem.classList.remove('open');
  }

  setAccountMenuItems(): void {
    this.accountMenuItems = [
      {
        label: this.translocoService.translate('logout'),
        icon: 'icon-logout-outline -mt-3px',
        command: () => this.authService.logout(),
      },
    ];
  }

  onHideHelp() {
    window.location.hash = '';
  }

  ngOnDestroy(): void {
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }
}
